// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__qMKG8","bigColWidth":"Table_bigColWidth__2qnJj","biggerColWidth":"Table_biggerColWidth__2GKAt","row":"Table_row__1lnsq","col":"Table_col__3Bunr"};